import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { installHandshakeListener } from './postmessage';

// Install the listener before React mounts so we never miss a handshake
// message that arrives during the initial tick.
installHandshakeListener();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Missing #root element');

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
